export const pricing = {
  title: "Escolha seu plano",
  subtitle: "Selecione o plano perfeito para suas necessidades de IA",
  monthly: "Mensal",
  yearly: "Anual",
  yearlyDiscount: "25% de desconto",
  contactUs: "Contate-nos",
  getStarted: "Começar",
  mostPopular: "Mais Popular",
  currentPlan: "Plano Atual",
  tiers: {
    free: {
      name: "Free",
      description: "Perfeito para testes e exploração",
      price: "R$ 0.00",
      features: [
        "Política de limites diários",
        "Acesso a modelos gratuitos",
        "Todos os recursos disponíveis",
      ],
    },
    prepaid: {
      name: "Pré-pago",
      description: "Pague apenas pelo que usar, sem compromisso, a partir de",
      price: "R$ 36,00",
      features: [
        "Depositar qualquer valor",
        "Pague somente o que usar",
        "Créditos nunca expiram",
        "Sem compromisso mensal",
        "Suporte básico",
        "Análise detalhada do uso",
      ],
    },
    subscription: {
      name: "Pro",
      description: "Melhor valor para usuários regulares",
      price: "R$ 120,00",
      yearlyPrice: "R$ 1080,00",
      period: "/mês",
      yearlyPeriod: "/ano",
      features: [
        "Todos os modelos premium incluídos",
        "Sem limites de uso",
        "Suporte prioritário",
        "Análise avançada",
      ],
    },
    enterprise: {
      name: "Enterprise",
      description: "Soluções personalizadas para grandes equipes",
      price: "Personalizado",
      features: [
        "Acesso à API",
        "Treinamento de modelo personalizado",
        "Suporte dedicado",
        "Garantia SLA",
        "Integrações personalizadas",
        "Volume Discounts",
      ],
    },
  },
  secondaryTitle: "O que dá para fazer com R$ 36?",
  secondarySubtitle:
    "R$ 36 são suficientes para criar muitas imagens e vídeos.",
  canBeDoneWith36Credits: [
    {
      title: "Gerar 1800 imagens 512x512",
    },
    {
      title: "0.4M tokens GPT-4o",
    },
    {
      title: "Gerar 13 vídeos de 5 segundos",
    },
    {
      title: "0.8M tokens Claude 3.5 Sonnet",
    },
    {
      title: "1200 tarefas de Re-ranking corporativo (Cohere)",
    },
    {
      title: "3.4M tokens da Maritaca (Sabiá 3)",
    },
    {
      title: "18 tarefas de Decoração de Interiores",
    },
    {
      title: "12M tokens DeepSeek V3",
    },
  ],
};
